import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import DataMapperSourceStore from "./DataMapperSourceStore";

const sourceStore = (rootStore: RootStore) =>
  rootStore.dataMapperSourceViewStore as DataMapperSourceStore;

/**
 * Data Mapper → Data Source: test, connect and save this tab's source for the
 * open profile (the standalone tool's step 1). Gated like the Profiles route
 * (see dataMapperProfiles.Route.ts): authentication here, operator tier in the
 * store and on every API call.
 */
const dataMapperSourceRoute: RouteType[] = [
  {
    name: "Data Mapper Source",
    path: "/data-mapper/source",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Data Source",
        enableRefreshButton: true,
        component: () => import("./DataMapperSource.Header"),
      },
      body: {
        component: () => import("./DataMapperSource.Body"),
        grayBackground: true,
      },
    },
    group: "Data Mapper",
    searchAliases: ["data mapper source", "source database", "connect sql server", "data source"],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      void sourceStore(rootStore)?.enter();
    },
    onExit: ({ rootStore }) => {
      sourceStore(rootStore)?.reset();
    },
  },
];

export default dataMapperSourceRoute;
